export const allowRedirectToMobileApp = true;

export const allowedShowGrammarVocabulary = false;
